import { createSignal, createMemo, onMount, For, Show } from 'solid-js';
import { useSFetch } from '../hooks/sfetch';
import Text from '../components/Text';
import { EmptyState } from '../components/EmptyState';
import { useTranslation } from '../hooks/useTranslation';
import UserGrantsAdmin from '../components/UserGrantsAdmin';
import { User } from '../components/UserContextProvider';

export default function AdminLicenses() {
    const sfetch = useSFetch();
    const { t } = useTranslation();
    const [users, setUsers] = createSignal<User[]>([]);
    const [search, setSearch] = createSignal('');
    const [selectedId, setSelectedId] = createSignal<string>('');
    const [loading, setLoading] = createSignal(true);

    onMount(async () => {
        const res = await sfetch('/api/User/Users');
        if (res.ok) setUsers((res.value ?? []) as User[]);
        setLoading(false);
    });

    const filtered = createMemo(() => {
        const term = search().toLowerCase().trim();
        const all = users();
        if (!term) return all;
        return all.filter(u => u.username.toLowerCase().includes(term));
    });

    return (
        <div class="dashboard-page" style={{ 'max-width': '1100px', margin: '0 auto', padding: 'var(--spacing-lg)' }}>
            <div class="v" style={{ gap: 'var(--spacing-lg)' }}>
                <div class="v" style={{ gap: 'var(--spacing-xs)' }}>
                    <h1 style={{ margin: 0 }}><Text val="ADMIN_LICENSES_TITLE" /></h1>
                    <p style={{ color: 'var(--dark-text-muted)', margin: 0, 'font-size': 'var(--font-size-sm)' }}>
                        <Text val="ADMIN_LICENSES_HELP" />
                    </p>
                </div>

                <div class="fcard v" style={{ gap: 'var(--spacing-md)' }}>
                    <label class="v" style={{ gap: 'var(--spacing-xs)' }}>
                        <span style={{ 'font-size': 'var(--font-size-sm)', color: 'var(--dark-text-muted)' }}>
                            <Text val="ADMIN_LICENSES_FILTER" />
                        </span>
                        <input
                            type="text"
                            placeholder={t("ADMIN_LICENSES_USERNAME_PLACEHOLDER")}
                            value={search()}
                            onInput={e => setSearch(e.currentTarget.value)}
                        />
                    </label>

                    <label class="v" style={{ gap: 'var(--spacing-xs)' }}>
                        <span style={{ 'font-size': 'var(--font-size-sm)', color: 'var(--dark-text-muted)' }}>
                            <Text val="ADMIN_LICENSES_USER" />
                        </span>
                        <select value={selectedId()} onChange={e => setSelectedId(e.currentTarget.value)}>
                            <option value=""><Text val="ADMIN_LICENSES_PICK_USER" /></option>
                            <For each={filtered()}>{(u) => (
                                <option value={u.id}>{u.username}</option>
                            )}</For>
                        </select>
                    </label>

                    <Show when={!loading() && users().length === 0}>
                        <EmptyState icon="fa-user-slash" title={t('ADMIN_LICENSES_NO_USERS')} />
                    </Show>

                    <Show when={loading()}>
                        <div class="h" style={{ 'justify-content': 'center', padding: 'var(--spacing-2xl)', color: 'var(--dark-text-muted)' }}>
                            <i class="fa-solid fa-spinner fa-spin fa-2x" />
                        </div>
                    </Show>
                </div>

                <Show when={selectedId()}>
                    <UserGrantsAdmin userId={selectedId()} />
                </Show>
            </div>
        </div>
    );
}
